import { render, staticRenderFns } from "./DoctorPageLpuListBody.vue?vue&type=template&id=55012962&scoped=true&"
import script from "./DoctorPageLpuListBody.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuListBody.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorPageLpuListBody.vue?vue&type=style&index=0&id=55012962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55012962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55012962')) {
      api.createRecord('55012962', component.options)
    } else {
      api.reload('55012962', component.options)
    }
    module.hot.accept("./DoctorPageLpuListBody.vue?vue&type=template&id=55012962&scoped=true&", function () {
      api.rerender('55012962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListBody.vue"
export default component.exports